import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { WorkflowExecutionMap } from '@/types/workflowHistory'

interface WorkflowRunHistoryInitialState {
  runs?: WorkflowExecutionMap,
}

const initialState: WorkflowRunHistoryInitialState = {
  runs: undefined
}

const setWorkflowRun = (
  state: WorkflowRunHistoryInitialState = initialState,
  action: PayloadAction<WorkflowExecutionMap>
) => {
  return {
    ...state,
    runs: action.payload
  }
}

const workflowRunHistorySlice = createSlice({
  name: 'workflowRunHistory',
  initialState,
  reducers: {
    setWorkflowRun
  }
})

export const workflowRunHistoryReducer = workflowRunHistorySlice.reducer
export const workflowRunHistoryActions = workflowRunHistorySlice.actions
